import { ClosingEntry, Comment, DocumentLink, FcpTreeItemType, Task } from './fcp.model';

export interface FcpTreeItem {
    name: string; // name of the item
    openingValue: number; // opening value of the item
    closingValue: number; // closing value of the item
    adjustedValue: number; // closing value of the item
    tasks: Task[]; // All tasks of the checklist
    checklistname: string; // name of checklist used to create the tasks
    comments: Comment[]; // All comments to the item
    documents: DocumentLink[]; // All uploaded documents to the item
    closingEntries: ClosingEntry[]; // All closing entries of the item
    children: FcpTreeItem[]; // all children of the item
    type: FcpTreeItemType; // Determines the type of the fcp tree item
    uid: string; // unique identifier of the item
    active: boolean; // Determines if the item is active
    treeItemName?: string; // name of the original tree item
    isDefaultChecklistDeleted?: boolean;
}

export class FcpTreeItemModel implements FcpTreeItem {
    name: string; // name of the item
    openingValue: number; // opening value of the item
    closingValue: number; // closing value of the item
    adjustedValue: number; // closing value of the item
    tasks: Task[]; // All tasks of the checklist
    checklistname: string; // name of checklist used to create the tasks
    comments: Comment[]; // All comments to the item
    documents: DocumentLink[]; // All uploaded documents to the item
    closingEntries: ClosingEntry[]; // All closing entries of the item
    children: FcpTreeItem[]; // all children of the item
    type: FcpTreeItemType; // Determines the type of the fcp tree item
    uid: string; // unique identifier of the item
    active: boolean; // Determines if the item is active

    constructor(
        name: string,
        openingValue: number,
        closingValue: number,
        tasks: Task[],
        checklistname: string,
        comments: Comment[],
        documents: DocumentLink[],
        closingEntries: ClosingEntry[],
        children: FcpTreeItem[],
        type: FcpTreeItemType,
        uid: string,
        active: boolean,
        adjustedValue: number = 0,
    ) {
        this.name = name;
        this.openingValue = openingValue;
        this.closingValue = closingValue;
        this.tasks = tasks;
        this.checklistname = checklistname;
        this.comments = comments;
        this.documents = documents;
        this.closingEntries = closingEntries;
        this.children = children;
        this.type = type;
        this.uid = uid;
        this.active = active;
        this.adjustedValue = adjustedValue;
    }
}
